import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllStudentsUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllStudents implements GetAllStudentsUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllStudentsUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAllStudentsUseCaseInterface.Params,
  ): Promise<GetAllStudentsUseCaseInterface.Result> {
    const { page, length, ...restParams } = params;

    const requestUrl = `${this.url}/${page}/${length}`;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(requestUrl, restParams as any),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
